// extracted by mini-css-extract-plugin
export var postMeta = "post-module--post-meta--2SNYO";
export var pagination = "post-module--pagination--2K15k";
export var endingSnippet = "post-module--ending-snippet--1brq6";